import { SynthesisValues } from "../../component/management-report/generator/observation-generator/synthesis-generator/synthesis-generator";
import { LocalAuthority, Result } from "../../model";
import * as ComparaisonDomain from "./comparaison-domain";

export function getSynthesisValues(localAuth: LocalAuthority, year: number): SynthesisValues {

    let recetteFct = getValue(true, true, localAuth, year);
    let depensesFct = getValue(false, true, localAuth, year);
    let reportNm1Fct = getReportNm1(true, localAuth.results, year);
    let resultatFct = floatSubstraction(recetteFct, depensesFct);
    let resSectFct = floatAddition(resultatFct, reportNm1Fct);
    let recetteInv = getValue(true, false, localAuth, year);
    let depensesInv = getValue(false, false, localAuth, year);
    let reportNm1Inv = getReportNm1(false, localAuth.results, year);
    let resultatInv = floatSubstraction(recetteInv, depensesInv);
    let resSectInv = floatAddition(resultatInv, reportNm1Inv);
    let resGlobal = floatAddition(resSectFct, resSectInv);
    let ret = {
        recetteFct: recetteFct,
        depensesFct: depensesFct,
        resultatFct: resultatFct,
        reportNm1Fct: reportNm1Fct,
        resSectFct: resSectFct,
        recetteInv: recetteInv,
        depensesInv: depensesInv,
        resultatInv: resultatInv,
        reportNm1Inv: reportNm1Inv,
        resSectInv: resSectInv,
        resGlobal: resGlobal,
    }
    return ret;
}

function getValue(isReceipt: boolean, isFct: boolean, localAuth: LocalAuthority, year: number): number {
    let chapters = ComparaisonDomain.GetChapterList(localAuth.accounts, isFct, !isReceipt);

    let total = 0;
    chapters.forEach(o => {
        total = floatAddition(total, ComparaisonDomain.getChapterAmountForYear(localAuth.observations, localAuth.accounts, year, o.chapitreNumber, isReceipt));
    })
    return total;
}

function getReportNm1(isFct: boolean, res: Result[], year: number): number {
    let idx = res.findIndex(o => o.year == year - 1 && o.operation == isFct);
    return idx != -1 ? res[idx].amount : 0;
}

function floatAddition(a: number, b: number): number {
    return (a * 100 + b * 100) / 100
}

function floatSubstraction(a: number, b: number): number {
    return (a * 100 - b * 100) / 100
}



// WEBPACK FOOTER //
// ./src/domain/sfp/synthesis-domain.ts